export default __webpack_public_path__ + "static/media/onboard_lock.42d74f50.svg";